import { Grid2 as Grid, Button, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore, Delete } from '@mui/icons-material';
import { CustomControlledInput } from "./CustomControlledInput";
import CommonCard from '../components/common_card';
import { TypographyBold } from '../style/typography';

const PartnerList = ({
    control,
    partners,
    expandedPartner,
    companies,
    handleEditClick,
    handleCancelEdit,
    handleDeleteClick,
    handleEditSubmit,
    openDialog,
    isDisabled
}) => {
    return (
        <Grid size={{ xs: 12 }}>
            <CommonCard
                child={
                    <Grid container spacing={3} sx={{ padding: 3 }}>
                        <Grid size={{ xs: 12 }}>
                            <TypographyBold>
                                連絡先担当者一覧
                            </TypographyBold>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            {partners.map((partner) => (
                                <Accordion
                                    key={partner.uuid}
                                    expanded={expandedPartner === partner.uuid}
                                    onChange={() => {
                                        if (expandedPartner === partner.uuid) {
                                            handleCancelEdit();
                                        } else {
                                            handleEditClick(partner);
                                        }
                                    }}
                                    sx={{ mb: 1 }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls={`partner-content-${partner.uuid}`}
                                        id={`partner-header-${partner.uuid}`}
                                    >
                                        <div>
                                            <Typography variant="h6" component="div">
                                                {partner.person_name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {partner.partner_company_name} -{' '}
                                                {partner.tel}
                                            </Typography>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2} sx={{ paddingTop: 3 }}>
                                            {/* 所属会社 */}
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <CustomControlledInput
                                                    name="editPartnerCompanyPerson.partner_company_uuid"
                                                    control={control}
                                                    label="所属会社"
                                                    type="select"
                                                    multiple={false}
                                                    options={companies.map((c) => ({
                                                        value: c.uuid,
                                                        label: c.name,
                                                    }))}
                                                    disabled={isDisabled}
                                                />
                                            </Grid>
                                            {/* 氏名 */}
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <CustomControlledInput
                                                    name="editPartnerCompanyPerson.person_name"
                                                    control={control}
                                                    label="氏名"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 20 }}
                                                    disabled={isDisabled}
                                                />
                                            </Grid>
                                            {/* 電話番号（ハイフン無し） */}
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <CustomControlledInput
                                                    name="editPartnerCompanyPerson.tel"
                                                    control={control}
                                                    label="電話番号（ハイフン無し）"
                                                    inputProps={{ maxLength: 11, pattern: '[0-9]*' }}
                                                    onKeyPress={(e) => {
                                                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                                                    }}
                                                    disabled={isDisabled}
                                                />
                                            </Grid>
                                            {/* 主担当者フラグ */}
                                            <Grid size={{ xs: 12, md: 3 }}>
                                                <CustomControlledInput
                                                    name="editPartnerCompanyPerson.is_main_person"
                                                    control={control}
                                                    label="主担当者"
                                                    type="checkbox"
                                                    sx={{ mt: 1 }}
                                                    disabled={isDisabled}
                                                />
                                            </Grid>
                                            <Grid
                                                size={{ xs: 12 }}
                                                display="flex"
                                                justifyContent="space-between"
                                                gap={2}
                                                sx={{ mt: 2 }}
                                            >
                                                {/* 削除ボタン */}
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => handleDeleteClick(partner)}
                                                    startIcon={<Delete />}
                                                    disabled={isDisabled}
                                                >
                                                    削除
                                                </Button>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    {/* キャンセルボタン */}
                                                    <Button variant="outlined" onClick={handleCancelEdit} disabled={isDisabled}>
                                                        キャンセル
                                                    </Button>
                                                    {/* 保存ボタン */}
                                                    <Button
                                                        variant="contained"
                                                        // 連絡先一覧画面修正開始
                                                        onClick={handleEditSubmit((data) => {
                                                            const selectedCompany = companies.find(c => c.uuid === data.editPartnerCompanyPerson.partner_company_uuid);
                                                            openDialog('save', {
                                                                ...data.editPartnerCompanyPerson,
                                                                partner_company_name: selectedCompany ? selectedCompany.name : '',
                                                            });
                                                        })}
                                                        // 連絡先一覧画面修正終了
                                                        sx={{
                                                            backgroundColor: 'rgba(124, 183, 10, 1.0)',
                                                            '&:hover': { backgroundColor: 'rgba(124, 183, 10, 0.8)' }
                                                        }}
                                                        disabled={isDisabled}
                                                    >
                                                        保存
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Grid>
                    </Grid>
                }
            />
        </Grid>
    );
};
export default PartnerList;